import React from "react";
import { Link } from "react-router-dom";

import { assetImg } from "@/modules/moduleImporter";

//Lobby stars
import img_star_dark from "@/assets/img/img_star_dark.svg";
import img_star_lit from "@/assets/img/img_star_lit.svg";

import img_bet_closed from "@/assets/img/img_bet_closed.png";

import {
	historyOnlyGames,

	GameStatistics,
	History,
	RoadmapLarge,
	RoadmapSmall,

	getTranslatedGameName,

	isBetClosed,
	timeLeftStrToto,
} from "@/modules/commonMobile";

import {
	IGameObjectType,
	ILanguageType,
	ITimerObjectType,
	GenericMouseClickVoid,
	IKeyStringArrayDict
} from "@/types/GlobalTypes";

import {
	getBasePcode,
	getAssetPcode,
	getFirstNotEmptyPcode,
	getGameVariants,
	isTotoGame,
	getGroupCode,
	getGroupSize,
} from "@/modules/gamePcode";

interface IProps {
	games: IGameObjectType;
	timers: ITimerObjectType;
	langdata: ILanguageType;

	/**
	 * This may be either "toto", base pcode, or pcode depending on gameGroups
	 */
	pcode: string;
	orientation: string;

	ingroup: boolean;
	gameGroups: IKeyStringArrayDict;

	activeHover: string;

	showAllHistory: boolean;
	showAllRoadmap: boolean;
	showLobbyGameGroup: boolean;

	setLobbyRoadmapFilter: GenericMouseClickVoid;

	toggleFavourite: GenericMouseClickVoid;
	favouritedGames: string[];

	handleTouchDown: (e: any) => void;
	handleTouchRelease: (e: any) => void;

	activateGameGroup?: GenericMouseClickVoid;
}


export default class LobbyMobileGame extends React.Component<IProps> {
	// Touch & hold overlay
	showOverlay = true;

	getTargetURL = (pcode: string) => "/play/" + pcode;

	get firstNotEmptyPcode() {
		const { games, pcode } = this.props;
		return getFirstNotEmptyPcode(games, pcode);
	}

	get displayedPcode() {
		const { games, pcode } = this.props;

		return games[pcode]
			? pcode
			: this.firstNotEmptyPcode;
	}

	get basePcode() {
		return getBasePcode(this.displayedPcode);
	}

	get assetPcode() {
		return getAssetPcode(this.displayedPcode);
	}

	/**
	 *  The type of game history doesn't have any other variation
	 */
	get hasFullHistory() {
		const { pcode } = this.props;
		return ["m7", "m19", "m24", "m39"].includes(pcode);
	}

	get hasLargeRoadmap() {
		return ["m22", "m23", "m27", "m28", "m38"].includes(this.basePcode);
	}

	get gameIcon() {
		return assetImg(
			"game_icon",
			`${this.assetPcode}_wh.svg`,
			"",
			"icon-game"
		);
	}

	get isNewGame() {
		const {
			showAllHistory,
			showAllRoadmap,
			games,
			pcode
		} = this.props;

		return (
			!showAllHistory &&
			!showAllRoadmap &&
			games[pcode] &&
			games[pcode].newgame === "1"
		);
	}

	private newGameBadgeFragment() {
		if (!this.isNewGame)
			return null;

		return (
			<img className="new-game-badge"
				src="/assets/img/new-mobile.png"
				alt="New Game" />
		);
	}

	get touchAnimationProps() {
		const {
			handleTouchDown,
			handleTouchRelease,
		} = this.props;

		return {
			//For 3D animation
			onTouchStart: handleTouchDown,
			onTouchEnd: handleTouchRelease,
			onMouseDown: handleTouchDown,
			onMouseUp: handleTouchRelease
		}
	}

	get linkProps() {
		const {
			pcode
		} = this.props;

		return {
			className: "game-hover-overlay",
			pcode,
			...this.touchAnimationProps
		};
	}

	/**
	 * The actual game (not inside a group, or if it's Roulette B without the main Roulette game)
	 */
	get displayedGame() {
		return this.props.games[this.displayedPcode] || null;
	}

	get timeLeftComponent() {
		const { timers } = this.props;
		const { displayedPcode } = this;
		const timerObj = timers[displayedPcode];

		if (!timerObj)
			return null;

		const { time: timeLeft } = timerObj;
		const betClosed = isBetClosed(timeLeft);

		return (
			isTotoGame(displayedPcode) &&
				!betClosed
				? (
					<div className="time-left-v5">
						<div>
							{timeLeftStrToto(timeLeft)}
						</div>
					</div>
				) : (
					<div className="time-left">
						{
							betClosed ?
								<img src={img_bet_closed} alt="bet closed" /> :
								<div>
									{timeLeft}
								</div>
						}
					</div>
				)
		);
	}

	get favouriteStarComponent() {
		const { favouritedGames } = this.props;

		return (
			favouritedGames.includes(this.basePcode) ?
				<img src={img_star_lit} alt="is fav" /> :
				<img src={img_star_dark} alt="not fav" />
		);
	}

	get isHovered() {
		const {
			activeHover,
			pcode
		} = this.props;

		return activeHover === pcode;
	}

	private game3DImageFragment() {
		const {
			showAllRoadmap,
			showAllHistory,
		} = this.props;

		const still3D = this.assetPcode,
			anim3D = `anim-${this.assetPcode}.gif`;

		return (
			!(showAllRoadmap || showAllHistory) ? (
				!this.isHovered
					? (
						assetImg("3d", still3D, "", "game-3d")
					) : (
						<div className={"prev-3d-game game-" + this.assetPcode}>
							{assetImg("3d", anim3D)}
						</div>
					)
			) : null
		);
	}

	private roadmapFiltersFragment() {
		const
			{ pcode, showAllRoadmap, setLobbyRoadmapFilter } = this.props,
			{ displayedGame, displayedPcode } = this,
			{ activeRoadmapFilter, roadmapFilters } = displayedGame;

		return (
			/* Roadmap Filters */
			!this.isHovered &&
				(
					showAllRoadmap &&
					!(pcode === "m7" || pcode === "m19") &&
					roadmapFilters &&
					roadmapFilters.length > 1
				) ? (
				<div className="roadmap-options">
					{
						roadmapFilters.map((filter, idx) => (
							<div key={"g_rF_" + pcode + "_" + idx}
								className={
									activeRoadmapFilter === filter
										? "active"
										: ""}

								{...{
									game: displayedPcode,
									filter
								}}

								onClick={setLobbyRoadmapFilter}>

								<div>
									{idx + 1}
								</div>
							</div>
						))
					}
				</div>
			) : null
		);
	}

	private historyFragment() {
		const
			{ displayedGame } = this,
			{
				showAllRoadmap,
				showAllHistory,
				pcode,
				langdata,
				showLobbyGameGroup
			} = this.props,
			{ historyBlink } = displayedGame,
			commonProps = {
				key: `LMG_GH_${pcode}`,
				pcode: this.basePcode,
				historyBlink,
				lobbyMobile: true,
				langdata,
				showLobbyGameGroup
			};

		return (
			!this.isHovered &&
				(
					showAllHistory ||
					(showAllRoadmap && (historyOnlyGames.indexOf(pcode) >= 0))
				) ? (
				this.hasLargeRoadmap
					? (
						<History
							{...commonProps}
							history={
								displayedGame.roadmap
									? displayedGame.roadmap.big_road
									: []
							}
							small={false}
						/>
					) : (
						<History
							{...commonProps}
							history={displayedGame.history || []}
						/>
					)
			) : null
		);
	}

	private roadmapFragment() {
		const {
			langdata,
			showAllHistory,
			showAllRoadmap,
			showLobbyGameGroup,
			pcode
		} = this.props;

		const { displayedGame } = this;
		const { historyBlink } = displayedGame;

		const commonProps = {
			key: "LMG_RS_" + pcode,
			pcode: this.basePcode,
			lobbyMobile: true,
			showLobbyGameGroup,
			historyBlink,
			filter: displayedGame.activeRoadmapFilter
		}

		return (
			/* Roadmap component */
			!this.isHovered &&
				(
					(showAllHistory && (pcode === "m24")) ||
					showAllRoadmap //Every other game
				) ? (
				this.hasLargeRoadmap
					? <RoadmapLarge
						{...commonProps}
						history={
							displayedGame.roadmap
								? displayedGame.roadmap.big_road
								: []
						}
						type="big-road"
						small={false}
					/>
					: <RoadmapSmall
						{...commonProps}
						langdata={langdata}
						history={displayedGame.history || []}
						orientation={this.props.orientation}
					/>
			) : null
		);
	}

	get roadmapDescriptionComponent() {
		const { displayedGame } = this;

		return (
			<div className="roadmap-description">
				{
					displayedGame.roadmapText
						? displayedGame.roadmapText[
							displayedGame.activeRoadmapFilter
						] : null
				}
			</div>
		);
	}

	render() {
		const {
			games,
			langdata,
			pcode,
			ingroup,
			showLobbyGameGroup,
			gameGroups
		} = this.props;

		//Group Identifiers
		const
			groupCode = getGroupCode(pcode),
			hasGroup = getGroupSize(gameGroups[groupCode]) > 1;

		const { displayedGame } = this;

		// game clones
		const gameVariants = getGameVariants(games, this.basePcode);

		// const isPhaserGame = hasPhaserGame(pcode);
		const targetGameURL = this.getTargetURL(this.displayedPcode); // replaceGameNameWithURL(game.name);

		return (
			<div key={"game_" + pcode}
				{...{ pcode }}
				className={"game-box" +
					(this.hasFullHistory ? " full-history" : "") +
					// for Game Grouping
					(showLobbyGameGroup ? " full-width" : "")
				}>

				{this.newGameBadgeFragment()}
				{this.game3DImageFragment()}

				{this.roadmapFiltersFragment()}

				{this.historyFragment()}
				{this.roadmapFragment()}

				<div className="game-game">
					<div className="game-game-right">
						<div className="fav-box"
							{...{ pcode: this.displayedPcode }}
							onClick={this.props.toggleFavourite}>
							{
								this.favouriteStarComponent
							}
						</div>

						{this.gameIcon}

						<p>
							<span>
								{
									ingroup ?
										getTranslatedGameName(langdata, this.displayedPcode, true) : (
											gameVariants.length > 1 ?
												getTranslatedGameName(langdata, this.basePcode) :
												getTranslatedGameName(langdata, this.firstNotEmptyPcode, false, hasGroup)
										)
								}
							</span>
						</p>


						{
							//Copied from MaximizeMobileGame
							(showLobbyGameGroup && this.basePcode === "m22") ||
								(showLobbyGameGroup && this.basePcode === "m38") ?
								<GameStatistics
									pcode={pcode}
									history={
										displayedGame.roadmap
											? displayedGame.roadmap.big_road.slice(0)
											: []
									}

									filters={games[pcode].roadmapFilters}
									langdata={langdata}
									mobileHome={true}
								/> : null
						}
					</div>

					{this.timeLeftComponent}
				</div>

				{
					showLobbyGameGroup &&
						!["m22", "m38"].includes(this.basePcode)
						? this.roadmapDescriptionComponent
						: null
				}

				{
					this.showOverlay ? (
						//Link to open game group
						!showLobbyGameGroup &&
							hasGroup
							?
							<div className="game-hover-overlay group"
								{...{
									pcode,
									mobile: "true",
									group: groupCode
								}}

								//For 3D animation
								{...this.touchAnimationProps}

								onClick={this.props.activateGameGroup}
							/>
							:
							//Link to the game
							<Link
								to={targetGameURL}
								{...this.linkProps}
							/>
					) : null
				}
			</div>
		);
	}
}